export default __webpack_public_path__ + "static/media/styled-components.fedb2926.png";